import type React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Detail } from '../components/Detail';
import { releaseData } from '../data';

export const ReleaseDetailPage: React.FC = () => {
  const { release: releaseSlug } = useParams<{ release: string }>();
  const currentRelease = releaseData.find((rel) => rel.detail_link === releaseSlug);

  if (!currentRelease) {
    return <Navigate to="/404" replace />;
  }

  return <Detail release={currentRelease} />;
};

export default ReleaseDetailPage;
